import { Button } from "@/modules/shared/ui/components/button"
import {
  FaArrowLeft,
  FaArrowRight,
  FaSpinner,
  FaCheckCircle,
} from "react-icons/fa"

interface EmployeeOnboardingMultiStepFormFooterProps {
  currentStep: number
  totalSteps: number
  onPrevious: () => void
  onNext: () => void
  onSubmit: () => void
  isSubmitting?: boolean
  isSaving?: boolean
  isReadOnly?: boolean
  submitLabel?: string
  canSubmit?: boolean
}

export function EmployeeOnboardingMultiStepFormFooter({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting = false,
  isSaving = false,
  isReadOnly = false,
  submitLabel = "Submit",
  canSubmit = true,
}: EmployeeOnboardingMultiStepFormFooterProps) {
  const isLastStep = currentStep === totalSteps - 1
  const isSubmitDisabled = isLastStep
    ? isSubmitting || !canSubmit
    : isSubmitting

  return (
    <footer className="bg-card border-t border-border px-4 py-4">
      <div className="max-w-4xl mx-auto relative flex justify-between gap-2">
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={currentStep === 0}
          className="gap-1.5"
        >
          <FaArrowLeft className="w-3 h-3" />
          <span className="hidden sm:inline">Previous</span>
        </Button>

        {isSaving && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <FaSpinner className="w-3 h-3 animate-spin" />
            <span className="hidden sm:inline ml-1.5">Saving Your Data...</span>
          </div>
        )}

        {isReadOnly ? (
          // In read-only mode show navigation but hide submit
          !isLastStep && (
            <Button variant="outline" onClick={onNext} className="gap-1.5">
              <span className="hidden sm:inline">Next</span>
              <FaArrowRight className="w-3 h-3" />
            </Button>
          )
        ) : (
          <Button
            variant="outline"
            onClick={isLastStep ? onSubmit : onNext}
            disabled={isSubmitDisabled}
            className={`gap-1.5 ${isLastStep ? "bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-400 text-white hover:text-white disabled:opacity-50" : ""}`}
          >
            {isSubmitting ? (
              <>
                <FaSpinner className="w-3 h-3 animate-spin" />
                <span className="hidden sm:inline">Submitting...</span>
              </>
            ) : isLastStep ? (
              <span className="flex gap-1 items-center">
                {submitLabel} <FaCheckCircle className="w-3 h-3" />
              </span>
            ) : (
              <>
                <span className="hidden sm:inline">Next</span>
                <FaArrowRight className="w-3 h-3" />
              </>
            )}
          </Button>
        )}
      </div>
    </footer>
  )
}
